export const cropFilename = (text, length) => {
    const exp = /(?:\.([^.]+))?$/.exec(text);
    const ext = exp ? exp[1] : "";
    return text.length > length
        ? `${text.substring(0, length - (ext.length + 3))}… .${ext}`
        : text;
};
